import React, { Component } from 'react';
import Header from './Header';
import ComingSoon from './ComingSoon';

class Archive extends Component {
  constructor(props) {
    super(props)
  }


  render() {
    return (
      <div className="site-wrap">
        <Header page="archive" />
        <ComingSoon />
         <div className="news-wrap">
        </div>
      </div>
    );
  }
}

export default Archive;



// WEBPACK FOOTER //
// ./src/components/Archive.js